const validateTO2 = (rule,value,callback) =>{
  if(value>=10000000){
    callback(new Error('请输入10,000,000.00以内的数字！'));
  }else{
    callback();
  }

};
const validateTO3 = (rule,value,callback) =>{
  if(value>=10000){
    callback(new Error('请输入10,000.00以内的数字！'));
  }else{
    callback();
  }
};
import dayjs from 'dayjs'
export function omitNumber(e) {
  let value = e;
  value = value.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
  value = value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
  value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
  value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
  if (value.indexOf(".") < 0 && value != "") {
    //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
    value = parseFloat(value);
  }
  if(value=='.'){
    value = '0.'
  }
  return value;
}
export const startOption = {
  column: [
    {
      type: 'select',
      label: '服务地点',
      span: 24,
      display: true,
      formslot: true,
      prop: 'areaId',
      formslot: true,
      required: true,
      rules: [
        {
          required: true,
          message: '请选择服务地点'
        },

      ]
    },
    {
      label: "预计完成时间",
      prop: "estimateEndTime",
      type: "datetime",
      format: "yyyy-MM-dd HH:mm:ss",
      valueFormat: "yyyy-MM-dd HH:mm:ss",
      span: 24,
      // rules: [
      //   {
      //     required: true,
      //     message: '请选择预计完成时间'
      //   },
      //   {
      //     validator: function (rule, value, cb) {
      //       const beforeNow = dayjs(value).isBefore(dayjs())
      //       if (beforeNow) {
      //         cb(new Error('预计完成时间需要大于当前时间'))
      //       } else {
      //         cb()
      //       }
      //     },
      //   },
      // ]
    },
    {
      type: 'textarea',
      label: '备注',
      span: 24,
      display: true,
      formslot: true,
      prop: 'remark',

      required: true,
      rules: [
        {
          required: true,
          message: '请填写备注'
        },
        { min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }
      ]
    },
    {
      type: 'upload',
      label: '附件',
      span: 24,
      display: true,
      showFileList: true,
      multiple: true,
      limit: 10,
      dataType: 'array',
      propsHttp: {},
      canvasOption: {},
      prop: 'attachList',
      formslot: true,
      drag: true,

    }
  ],
  labelPosition: 'right',
  labelSuffix: '：',
  labelWidth: 120,
  gutter: 0,
  menuBtn: true,
  submitBtn: false,
  submitText: '保存',
  emptyBtn: false,
  menuPosition: 'right',
  detail: false,
  tabs: false
}

export const endOption = {
  labelPosition: 'right',
  labelSuffix: '：',
  labelWidth: 120,
  gutter: 0,
  menuBtn: true,
  submitBtn: false,
  submitText: '保存',
  emptyBtn: false,
  emptyText: '清空',
  menuPosition: 'right',
  detail: false,
  tabs: false,
  column: [
    {
      type: 'textarea',
      label: '备注',
      span: 24,
      display: true,
      formslot: true,
      prop: 'remark',
      rules: [{ required: true, message: '请输入备注' }, { min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }]
    },
    {
      type: 'input',
      label: '附件',
      span: 24,
      display: true,
      formslot: true,
      prop: 'attachList',


    }

  ],
}
